var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({class:['product-text', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id},domProps:{"innerHTML":_vm._s(_vm.props.item.name[_vm.props.locale])}},'div',_vm.data.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }